import React from 'react';
import { formatVND } from '../../utils/format';

interface Props {
  children: React.ReactNode;
  display?: React.CSSProperties['display'];
}

/**
 * Bọc giá trị nhạy cảm.
 * Blur/unblur được điều khiển bởi CSS class "privacy-mode" trên document.body
 * (set bởi PrivacyContext) — không cần đọc context ở đây.
 */
export function SensitiveValue({ children, display = 'inline-block' }: Props) {
  return (
    <span className="sv" style={{ display }}>
      {children}
    </span>
  );
}

/**
 * Shorthand: <Money value={x} /> thay cho <SensitiveValue>{formatVND(x)}</SensitiveValue>
 * Hỗ trợ prefix (vd: "+") và suffix.
 */
export function Money({ value, prefix, suffix }: { value: number; prefix?: string; suffix?: string }) {
  return (
    <span className="sv" style={{ display: 'inline-block' }}>
      {prefix}{formatVND(value)}{suffix}
    </span>
  );
}
